import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const categoryCreate = (params = '') => Http.post('/industry-sector-category', params)
export const categoriesList = (params = { per_page: 'all', sort: 'id', order: 'asc' }) =>
	Http.get(`/industry-sector-category${serialize(params)}`)
export const categoryByID = (params = '') => Http.get(`/industry-sector-category/${params}`)
export const categoryUpdate = (params = '') => Http.put(`/industry-sector-category/${params.id}`, params)
export const categoryDestroy = (params = '') => Http.delete(`/industry-sector-category/${params.id}`)
